exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-66d655f2]{cursor:pointer}.card[data-v-66d655f2]:hover{border:1px solid rgba(0,0,0,.3);background-color:#e2e2e2}.indisponible[data-v-66d655f2]{background-color:#fdd}.indisponible[data-v-66d655f2]:hover{border:1px solid rgba(0,0,0,.3);background-color:#e2b2b2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-66d655f2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/jeuxliste.vue
// module id = 25
// module chunks = 0